import { createGlobalStyle } from 'styled-components'

const GlobalBackground = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.accents.background};
  }`

export default GlobalBackground
